const LIST_APPLICATION_CLOUD = () => {
    return [
        {
            id: '0',
            title: '',
            data: [
                { id: 1, name_short: '《キャンペーンURL》', description: 'クラウドページの該当キャンペーンのURL' },
                { id: 2, name_short: '《生成日》', description: '出力日' }
            ]
        },
        {
            id: 1,
            title: '【概要情報】',
            data: [
                { id: 5, name_short: '《ステータス》', description: '進捗ステータス' },
                { id: 6, name_short: '《キャンペーン名》', description: 'キャンペーン名称' },
                { id: 7, name_short: '《ZACID》', description: 'ZACID' },
                { id: 8, name_short: '《SFID》', description: 'SFID' },
                { id: 9, name_short: '《キャンペーン種別》', description: 'キャンペーン種別' },
                { id: 10, name_short: '《応募種別》', description: '応募種別' }
            ]
        },
        {
            id: 2,
            title: '【期間関連】',
            data: [
                { id: 13, name_short: '《キャンペーン開始日》', description: 'キャンペーン開始年月日（曜日）' },
                { id: 14, name_short: '《キャンペーン開始時間》', description: 'キャンペーン開始時間' },
                { id: 15, name_short: '《キャンペーン開始》', description: 'キャンペーン開始年月日（曜日）時間' },
                { id: 16, name_short: '《キャンペーン終了日》', description: 'キャンペーン終了年月日（曜日）' },
                { id: 17, name_short: '《キャンペーン終了時間》', description: 'キャンペーン終了時間' },
                { id: 18, name_short: '《キャンペーン終了》', description: 'キャンペーン終了年月日（曜日）時間' },
                { id: 19, name_short: '《事務局開始日》', description: '事務局開始年月日（曜日）' },
                { id: 20, name_short: '《事務局開始時間》', description: '事務局開始時間' },
                { id: 21, name_short: '《事務局終了日》', description: '事務局終了年月日（曜日）' },
                { id: 22, name_short: '《事務局終了時間》', description: '事務局終了時間' },
                { id: 23, name_short: '《レシート有効期限開始》', description: 'レシート有効期限開始年月日（曜日）' },
                { id: 24, name_short: '《レシート有効期限終了》', description: 'レシート有効期限終了年月日（曜日）' },
                { id: 25, name_short: '《ハガキ有効条件》', description: 'ハガキ応募の場合　当日消印有効・必着' },
                {
                    id: 26,
                    name_short: '《年末年始休み》',
                    description: '年末年始休み、日付含む（該当キャンペーンに関連する年末年始がある場合は表示）'
                }
            ]
        },
        {
            id: 3,
            title: '【応募詳細】',
            data: [
                { id: 29, name_short: '《WEB：応募フォームURL》', description: '応募フォームURL' },
                {
                    id: 30,
                    name_short: [
                        '《WEB：応募条件①》',
                        '《ハガキ：応募条件①》',
                        '《X：応募条件①》',
                        '《Instagram：応募条件①》',
                        '《LINE：応募条件①》',
                        '《TikTok：応募条件①》',
                        '《店頭：応募条件①》',
                        '《アプリ：応募条件①》'
                    ],
                    description: '応募条件①（媒体ごとの）'
                },
                { id: 31, name_short: '《共通：応募条件①》', description: '応募条件①（共通）\n【フォーマット】\nX：後日抽選\nInstagram：先着' },
                {
                    id: 32,
                    name_short: [
                        '《WEB：応募条件②》',
                        '《ハガキ：応募条件②》',
                        '《X：応募条件②》',
                        '《Instagram：応募条件②》',
                        '《LINE：応募条件②》',
                        '《TikTok：応募条件②》',
                        '《店頭：応募条件②》',
                        '《アプリ：応募条件②》'
                    ],
                    description: '応募条件②（媒体ごとの）'
                },
                {
                    id: 33,
                    name_short: '《共通：応募条件②》',
                    description: '応募条件②（共通）\n【フォーマット】\nX：ハッシュタグ・フォロー\nInstagram：ハッシュタグ・メンション・フォロー'
                },
                {
                    id: 34,
                    name_short: [
                        '《WEB：応募方法》',
                        '《ハガキ：応募方法》',
                        '《X：応募方法》',
                        '《Instagram：応募方法》',
                        '《LINE：応募方法》',
                        '《TikTok：応募方法》',
                        '《店頭：応募方法》',
                        '《アプリ：応募方法》'
                    ],
                    description: 'キャンペーンの応募種別に対応した応募方法（媒体ごとの）'
                },
                {
                    id: 35,
                    name_short: '《共通：応募方法》',
                    description: 'キャンペーンの応募種別に対応した応募方法（共通）\n【フォーマット】\nX：～～～\nInstagram：～～～'
                },
                {
                    id: 36,
                    name_short: [
                        '《X：公式アカウント名》',
                        '《Instagram：公式アカウント名》',
                        '《LINE：公式アカウント名》',
                        '《TikTok：公式アカウント名》'
                    ],
                    description: '公式アカウント名（媒体ごとの）'
                },
                {
                    id: 37,
                    name_short: [
                        '《X：公式アカウントID》',
                        '《Instagram：公式アカウントID》',
                        '《LINE：公式アカウントID》',
                        '《TikTok：公式アカウントID》'
                    ],
                    description: '公式アカウントID（媒体ごとの）'
                },
                {
                    id: 38,
                    name_short: [
                        '《X：公式アカウント名＆ID》',
                        '《Instagram：公式アカウント名＆ID》',
                        '《LINE：公式アカウント名＆ID》',
                        '《TikTok：公式アカウント名＆ID》'
                    ],
                    description: '公式アカウント名（公式アカウントID）（媒体ごとの）'
                },
                {
                    id: 39,
                    name_short: '《共通：公式アカウント名＆ID》',
                    description:
                        '公式アカウント名（公式アカウントID）（共通）\n【フォーマット】\nX：パルディア公式（＠paldia）\nInstagram：パルディア公式（paldia）'
                },
                {
                    id: 40,
                    name_short: ['《X：ハッシュタグ》', '《Instagram：ハッシュタグ》', '《TikTok：ハッシュタグ》'],
                    description: 'CP指定ハッシュタグ（媒体ごとの）'
                },
                {
                    id: 41,
                    name_short: '《共通：ハッシュタグ》',
                    description: 'CP指定ハッシュタグ\n【フォーマット】\nX：#orange \nInstagram：#mango など'
                }
            ]
        },
        {
            id: 4,
            title: '【商品関連】',
            data: [
                { id: 44, name_short: '《購買条件》', description: '' },
                { id: 45, name_short: '《対象商品金額》', description: '対象商品金額入力' },
                { id: 46, name_short: '《対象商品個数》', description: '対象商品個数入力' },
                { id: 47, name_short: '《対象商品合計金額》', description: '対象商品合計金額入力' },
                { id: 48, name_short: '《流通合計金額》', description: '流通合計金額入力' },
                {
                    id: 49,
                    name_short: '《購買条件と金額詳細》',
                    description: '購買条件+金額詳細\n【フォーマット】\n対象商品(個数)：●個\n流通合計金額：●●円'
                },
                { id: 50, name_short: '《対象商品カテゴリ1》', description: '対象商品のカテゴリ' },
                { id: 51, name_short: '《対象商品カテゴリ2》', description: '対象商品のカテゴリのその先の分岐' },
                { id: 52, name_short: '《商品関連自由入力》', description: '対象商品名等の自由記述' },
                {
                    id: 53,
                    name_short: '《共通：対象商品カテゴリ》',
                    description:
                        'カテゴリー１+カテゴリ2+自由記述\n【フォーマット】\n食品：インスタント・麺（●●日清カップヌードル）\n飲料：お茶飲料・コーヒー飲料（●●サントリー全品）'
                }
            ]
        },
        {
            id: 5,
            title: '【告知サイト関連】',
            data: [
                { id: 56, name_short: '《キャンペーン告知》', description: 'キャンペーン告知がされる媒体' },
                { id: 57, name_short: '《LPサイト》', description: 'LP サイト' },
                { id: 58, name_short: '《公開期間》', description: '公開開始年月日（曜日）時間～公開終了年月日（曜日）時間' },
                {
                    id: 59,
                    name_short: '《IPコンテンツ》',
                    description: 'ありの場合下記詳細まで\nキャラクター\n芸能人\n声優\nインフルエンサー\nその他'
                },
                {
                    id: 60,
                    name_short: '《IPコンテンツ詳細含む》',
                    description: 'IPコンテンツの選択内容とその詳細まで含む\n【フォーマット】\nキャラクター：ミッキー\n芸能人：ジャニーズ'
                },
                { id: 61, name_short: '《キャンペーン主催情報》', description: 'キャンペーン主催情報の選択内容' },
                {
                    id: 62,
                    name_short: '《キャンペーン主催情報詳細含む》',
                    description:
                        'キャンペーン主催情報の選択内容とその詳細まで含む\n【フォーマット】\n流通単体キャンペーン：●●\nタイアップキャンペーン：流通数：60企業／メーカー数：2企業\n　流通詳細：イオン・サンドラッグ・●●\n　メーカー詳細：森永製菓・キリン'
                },
                { id: 63, name_short: '《タイアップ流通数》', description: '60企業' },
                { id: 64, name_short: '《タイアップ流通数報詳細含む》', description: '60企業\n　流通詳細：イオン・サンドラッグ・●●' },
                { id: 65, name_short: '《タイアップメーカー数》', description: '2企業' },
                { id: 66, name_short: '《タイアップメーカー数報詳細含む》', description: '2企業\n　メーカー詳細：森永製菓・キリン' }
            ]
        },
        {
            id: 6,
            title: '【賞品・当選関連】',
            data: [
                { id: 69, name_short: '《抽選(当選人数)》', description: '当選者数' },
                { id: 70, name_short: '《賞品進呈時期(発送時期・送付時期)》', description: '賞品進呈時期(発送時期・送付時期)' },
                { id: 71, name_short: ' 《賞品進呈時期日付部分》', description: '賞品進呈時期(発送時期・送付時期)日付部分' }
            ]
        },
        {
            id: 7,
            title: '【お問い合わせ関連】',
            data: [
                { id: 74, name_short: '《お問い合わせ事務局名》', description: 'キャンペーン名称+事務局' },
                { id: 75, name_short: '《キャンペーン事務局TEL》', description: 'お問い合わせ事務局の電話番号' },
                { id: 76, name_short: '《キャンペーン事務局Mailアドレス》', description: 'お問い合わせ事務局のメールアドレス' },
                { id: 77, name_short: '《お問い合わせDM対応アカウント》', description: 'DM対応アカウント \nX：●● \nInstagram：●●' },
                {
                    id: 78,
                    name_short: '《お問い合わせ事務局署名》',
                    description:
                        '《お問い合わせ事務局名》\nTEL：《事務局電話番号》\nMAIL：《事務局メールアドレス》\n受付時間：平日の《事務局開始時間》～《事務局終了時間》\n※土日祝日・年末年始（《年末年始休み》）を除く\n受付期間：《事務局終了日》まで'
                }
            ]
        },
        {
            id: 8,
            title: '【フォルダ・チャット関連】',
            data: [
                { id: 81, name_short: '《案件フォルダ》', description: '案件フォルダ' },
                { id: 82, name_short: '《見積もりフォルダ》', description: '見積もりフォルダ' }
            ]
        },
        {
            id: 9,
            title: '【受注範囲＆パートナー＆ツール】',
            data: [
                { id: 85, name_short: '《受注範囲大項目》', description: '資料系 お問い合わせ 応募収集 事務局関連 発送 制作関連 SNSアカウント関連' },
                {
                    id: 86,
                    name_short: '《受注範囲大項目+中項目》',
                    description: ''
                },
                {
                    id: 87,
                    name_short: '《受注範囲大項目+中項目+詳細》',
                    description:
                        '資料系 \n-応募規約・マニュアル・FAQ \nお問い合わせ\n-電話（03）\n-メール（独自ドメイン）\n応募収集\n-WEBフォーム（独自ドメイン）\n事務局関連\n-通数報告（●●）\n-抽選（●●）\n-重複確認（●●）\n-購買確認（●●）\n-当選・発送データ作成（●●）\n発送\n-宅配便（●●）\n制作関連\n-デザイン（●●）\nSNSアカウント関連\n-告知投稿（●●）'
                },
                { id: 88, name_short: '《受注範囲-資料系》', description: '応募規約 \nマニュアル \nFAQ \n配信文言 \n挨拶状 \nその他' },
                { id: 89, name_short: '《受注範囲-お問い合わせ》', description: '電話 \nメール \nDM \nその他' },
                { id: 90, name_short: '《受注範囲-お問い合わせ+詳細》', description: 'お問い合わせ \n-電話（03） \n-メール（独自ドメイン）' },
                { id: 91, name_short: '《受注範囲-応募収集》', description: 'はがき回収 \nWEBフォーム \nSNSツール その他' },
                { id: 92, name_short: '《受注範囲-応募収集+詳細》', description: '応募収集 \n-WEBフォーム（独自ドメイン）' },
                {
                    id: 93,
                    name_short: '《受注範囲-事務局関連》',
                    description:
                        '通数報告 \n抽選 \n重複確認 \n購買確認 \nデータ入力 \n配信関連 \n当選者用フォーム \n当選・発送データ作成 \n集計 \nその他'
                },
                {
                    id: 94,
                    name_short: '《受注範囲-事務局関連+詳細》',
                    description: '事務局関連 \n-通数報告（●●） \n-抽選（●●） \n-重複確認（●●） \n-購買確認（●●） \n-当選・発送データ作成（●●）'
                },
                { id: 95, name_short: '《受注範囲-発送》', description: '宅配便 \n冷蔵（宅配便） \n冷凍（宅配便） \n郵便 \nDM便 \nその他' },
                { id: 96, name_short: '《受注範囲-発送+詳細》', description: '発送 \n-宅配便（●●）' },
                { id: 97, name_short: '《受注範囲-制作関連》', description: 'デザイン \n印刷' },
                { id: 98, name_short: '《受注範囲-制作関連+詳細》', description: '制作関連 \n-デザイン（●●）' },
                { id: 99, name_short: '《受注範囲-SNSアカウント関連》', description: 'アカウント作成 \n告知投稿 \n告知配信 \n広告運用 \nその他' },
                { id: 100, name_short: '《受注範囲-SNSアカウント関連+詳細》', description: 'SNSアカウント関連 \n-アカウント作成（●●）' },
                {
                    id: 101,
                    name_short: '《パートナー一覧》',
                    description: '選択されているパートナーを一覧で表示 \nオペレーションセンター \nコールセンター香川'
                },
                {
                    id: 102,
                    name_short: '《パートナー：受注範囲-お問い合わせ》',
                    description: '選択されているパートナーを一覧で表示 \nコールセンター香川'
                },
                {
                    id: 103,
                    name_short: '《パートナー：受注範囲-応募収集》',
                    description: '選択されているパートナーを一覧で表示 \nオペレーションセンター'
                },
                {
                    id: 104,
                    name_short: '《パートナー：受注範囲-事務局関連》',
                    description: '選択されているパートナーを一覧で表示 \nオペレーションセンター'
                },
                {
                    id: 105,
                    name_short: '《パートナー：受注範囲-発送》',
                    description: '選択されているパートナーを一覧で表示 \nオペレーションセンター'
                },
                { id: 106, name_short: '《ツール一覧》', description: '選択されているツールを一覧で表示 \nATELU WEBCAS' },
                { id: 107, name_short: '《ツール：受注範囲-応募収集》', description: '選択されているツールを一覧で表示 \nATELU' },
                { id: 108, name_short: '《ツール：受注範囲-事務局関連》', description: '選択されているツールを一覧で表示 \nWEBCAS' },
                { id: 109, name_short: '《はがき回収のパートナー住所》', description: '受注範囲　→はがき回収　→どちらかの値' },
                {
                    id: 110,
                    name_short: '《パートナー会社住所》',
                    description: '受注範囲：【応募収集】→【はがき回収】のパートナー住所'
                },
                { id: 111, name_short: '《発送住所》', description: '受注範囲：【発送】→発送のパートナーの住所' }
            ]
        },
        {
            id: 10,
            title: '【お客様情報】',
            data: [
                { id: 114, name_short: '《発注元》', description: '発注元に選択されている企業名' },
                { id: 115, name_short: '《クライアント名》', description: 'エンドクライアントに選択されている企業名' },
                { id: 116, name_short: '《エンドクライアント担当者》', description: 'エンドクライアントに選択されている企業の担当者' },
                {
                    id: 117,
                    name_short: '《エンドクライアント担当者メールアドレス》',
                    description: 'エンドクライアントに選択されている企業の担当者のメール'
                },
                { id: 118, name_short: '《発注元担当者》', description: '発注元に選択されている企業の担当者' },
                { id: 119, name_short: '《発注元担当者メールアドレス》', description: '発注元に選択されている企業の担当者のメール' },
                { id: 120, name_short: '《主催者(流通)名》', description: 'お客様情報タブで「流通」の顧客種別と分類されている顧客の会社名の情報' },
                { id: 121, name_short: '《協賛メーカー》', description: 'お客様情報タブで「メーカー」の顧客種別と分類されている顧客の会社名の情報' }
            ]
        },
        {
            id: 11,
            title: '【事務局担当情報】',
            data: [
                { id: 122, name_short: '《営業担当》', description: '営業担当' },
                { id: 123, name_short: '《営業担当メールアドレス》', description: '営業担当のメール' },
                { id: 124, name_short: '《ディレクションメイン担当》', description: 'ディレクション担当のメイン' },
                { id: 125, name_short: '《ディレクションメイン担当メールアドレス》', description: 'ディレクション担当のメインのメール' },
                { id: 126, name_short: '《ディレクションサブ１担当》', description: 'ディレクション担当のサブ１' },
                { id: 127, name_short: '《ディレクションサブ１担当メールアドレス》', description: 'ディレクション担当のサブ１のメール' },
                { id: 128, name_short: '《ディレクションサブ２担当》', description: 'ディレクション担当のサブ2' },
                { id: 129, name_short: '《ディレクションサブ２担当メールアドレス》', description: 'ディレクション担当のサブ2のメール' },
                { id: 130, name_short: '《案件統括》', description: '案件統括のメイン' },
                { id: 131, name_short: '《案件統括メールアドレス》', description: '案件統括のメインのメール' },
                { id: 132, name_short: '《エスカレメイン担当》', description: 'エスカレ担当のメイン' },
                { id: 133, name_short: '《エスカレメイン担当メールアドレス》', description: 'エスカレ担当のメインのメール' },
                { id: 134, name_short: '《エスカレサブ担当》', description: 'エスカレ担当のサブ' },
                { id: 135, name_short: '《エスカレサブ担当メールアドレス》', description: 'エスカレ担当のサブのメール' },
                { id: 136, name_short: '《アルバイト》', description: 'アルバイト担当' }
            ]
        },
        {
            id: 12,
            title: '【賞品情報】',
            data: [
                { id: 139, name_short: '《タイトル賞品》', description: '賞品タイトルのみ羅列（複数ある場合その分羅列）' },
                {
                    id: 140,
                    name_short: '《賞品タイトル賞品名》',
                    description: '賞品タイトルと詳細（※賞品タイトルと賞品名が同一の場合は詳細不要。）\n【フォーマット】\nA賞●●\n-●●\n-●●\nB賞●●'
                },
                {
                    id: 141,
                    name_short: '《賞品タイトル当選者人数》',
                    description: '賞品タイトルと当選者人数\n【フォーマット】\nA賞●●（●名）\nB賞●●（●名）'
                },
                {
                    id: 142,
                    name_short: '《賞品タイトル賞品名当選者人数》',
                    description:
                        '賞品タイトルと詳細と当選者人数（※賞品タイトルと賞品名が同一の場合は詳細不要。）\n【フォーマット】\nA賞●●（●名）\n-●●\n-●●\nB賞●●（●名）'
                },
                {
                    id: 143,
                    name_short: '《賞品タイトル当選者人数抽選人数》',
                    description: '賞品タイトルと当選者人数と抽選人数\n【フォーマット】\nA賞●●（●名）：抽選人数●名\nB賞●●（●名）：抽選人数●名'
                },
                {
                    id: 144,
                    name_short: '《賞品種類》',
                    description:
                        '賞品タイトルと詳細と当選者人数と種類（※賞品タイトルと賞品名が同一の場合は詳細不要。）\n【フォーマット】\nA賞●●（●名）：現物\n-●●\n-●●\nB賞●●（●名）：デジタルギフト'
                },
                { id: 145, name_short: '《LINEのポイント》', description: '●●円分' },
                { id: 146, name_short: '《PayPayのポイント》', description: '●●円分' },
                { id: 147, name_short: '《Amazonのギフト》', description: '●●円分' },
                { id: 148, name_short: '《図書カードネットのギフト》', description: '●●円分' },
                { id: 149, name_short: '《EJOICAセレクトのギフト》', description: '●●円分' },
                { id: 150, name_short: '《nanacoのギフト》', description: '●●円分' },
                { id: 151, name_short: '《QUOのカードPay》', description: '●●円分' },
                { id: 152, name_short: '《えらべるのPay》', description: '●●円分' },
                { id: 153, name_short: '《賞品タイトル-賞品名》', description: '【フォーマット】\n「賞品タイトル\n賞品名\n当選人数」' },
                {
                    id: 154,
                    name_short: '《賞品の表示》',
                    description: '【フォーマット】\n「賞品タイトル：賞品名」　→中央揃える　（タイトルと賞品名は同一の場合：タイトルのみ表示）'
                },
                {
                    id: 155,
                    name_short: '《タイトル・賞品》',
                    description: '【フォーマット】\n「賞品タイトル\n賞品名」　　→中央揃える（タイトルと賞品名は同一の場合：タイトルのみ表示）'
                }
            ]
        },
        {
            id: 13,
            title: '【実施結果登録】',
            data: [
                {
                    id: 158,
                    name_short: [
                        '《WEB：応募数》',
                        '《ハガキ：応募数》',
                        '《店頭：応募数》',
                        '《アプリ：応募数》',
                        '《Instagram：応募数》',
                        '《LINE：応募数》',
                        '《X：応募数》',
                        '《TikTok：応募数》'
                    ],
                    description: '応募数（媒体ごとの）'
                },
                {
                    id: 159,
                    name_short: '《共通：応募数》',
                    description: '応募数（共通）\n【フォーマット】\n総応募数：●●件\nX応募数：●●件\nInstagram応募数：●●件'
                },
                {
                    id: 160,
                    name_short: ['《電話：お問い合わせ数》', '《メール：お問い合わせ数》', '《DM：お問い合わせ数》', '《その他：お問い合わせ数》'],
                    description: 'お問い合わせ数（媒体ごとの）'
                },
                {
                    id: 161,
                    name_short: '《共通：お問い合わせ数》',
                    description:
                        'お問い合わせ数（共通）\n【フォーマット】\n総お問い合わせ数：●●件\n電話お問い合わせ数：●●件\nメールお問い合わせ数：●●件'
                }
            ]
        },
        {
            id: 14,
            title: '【SNSアカウントの友だち・フォロー数】',
            data: [
                {
                    id: 163,
                    name_short: [
                        '《WEB：SNSアカウントの友だち・フォロー数》',
                        '《ハガキ：SNSアカウントの友だち・フォロー数》',
                        '《X：SNSアカウントの友だち・フォロー数》',
                        '《Instagram：SNSアカウントの友だち・フォロー数》',
                        '《LINE：SNSアカウントの友だち・フォロー数》',
                        '《TikTok：SNSアカウントの友だち・フォロー数》',
                        '《店頭：SNSアカウントの友だち・フォロー数》',
                        '《アプリ：SNSアカウントの友だち・フォロー数》'
                    ],
                    description: 'SNSアカウントの友だち・フォロー数（媒体ごとの）'
                },
                {
                    id: 164,
                    name_short: '《共通：SNSアカウントの友だち・フォロー数》',
                    description:
                        'SNSアカウントの友だち・フォロー数（共通）\n【フォーマット】\nX：開始時（●●）～終了時（●●）\nInstagram：開始時（●●）～終了時（●●）'
                },
                { id: 165, name_short: '《広告関連+媒体＆費用》', description: '' },
                { id: 166, name_short: '《キャン策ID》', description: '' }
            ]
        }
    ];
};

const configOption = {
    configSelectTemplate: {
        trackBy: 'id',
        label: 'name',
        error: false,
        errorField: '',
        isRemove: false
    },
    configEditor: {
        height: 600
    }
};

function convertNtoBr(text) {
    if (typeof text !== 'string') return text;
    return text.replace(/\n/g, '<br>');
}

export { LIST_APPLICATION_CLOUD, configOption, convertNtoBr };
